'use strict';

import React from 'react';
import Link from './Link';
import PureRenderMixin from '../mixins/PureRenderMixin';
import Icon from '../atoms/Icon';

var TabLink = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    onClick: React.PropTypes.func,
    to: React.PropTypes.string,
    color: React.PropTypes.oneOf(['light', 'dark']),
    params: React.PropTypes.object,
    active: React.PropTypes.bool,
    icon: React.PropTypes.string,
    mode: React.PropTypes.string
  },

  render() {
    const { icon } = this.props;

    return (
      <Link context='TabBar'
            bold={this.props.active}
            underline='never'
            {...this.props}>
        {icon &&
          <Icon name={icon}
                color={this.props.color}
                mode={this.props.mode} />
        }
        <div className='TabLink-extra'>
          {this.props.children}
        </div>
      </Link>
    );
  }
});

export default TabLink;



/** WEBPACK FOOTER **
 ** ./atoms/TabLink.jsx
 **/